import { BaseModel } from './base.model';
import { ISelectable } from '../interfaces';
import { Expose } from 'class-transformer';

export class SelectableModel extends BaseModel implements ISelectable {
  @Expose()
  value!: string | number | boolean;

  @Expose()
  viewValue!: string;
}
